module.exports = __webpack_public_path__ + "img/request-feature.653bb4e.webp";